export const isUndefined = (object?: any) => typeof object === "undefined";
